module.exports = __webpack_public_path__ + "static/media/lets-spread.bee1f504.png";